<template>
  <NuxtLink
    :to="localePath({name: 'ambitions-ambition', params: {ambition: ambition.slug}})"
    class="grid-content-rtl grid-overview-ambition !gap-0 overflow-hidden pt-0 no-underline"
  >
    <div class="relative overflow-hidden bg-black">
      <img
        v-if="ambition.active_image"
        class="image aspect-long absolute transition duration-500 hover:scale-110 lg:h-full"
        :src="ambition.active_image?.url"
        :alt="ambition.title"
      >
      <div class="lg:heading absolute left-12 top-8 text-xl font-bold !text-white">
        {{ ambition.title }}
      </div>
      <div
        class="icon absolute right-6 top-12"
      >
        <AmbitionIcon
          :ambition="ambition"
          class="size-16"
        />
      </div>
    </div>
    <div class="flex-col p-[50px]">
      <div class="lg:heading flex text-xl font-bold !text-white lg:hidden">
        {{ ambition.title }}
      </div>
      <SofieText
        class="prose-p:text-lg prose-p:font-medium mb-5 line-clamp-6 text-white max-lg:line-clamp-5 lg:mb-8"
        :value="ambition.text"
      />
      <div
        class="link-escape capitalize-first text-lg font-bold text-black underline decoration-transparent underline-offset-8 transition-colors duration-300 hover:text-white"
      >
        {{ $t('More') }} {{ ambition.title }}
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type {AmbitionsQuery} from '~/graphql/graphql';

const props = defineProps<{
  ambition: NonNullable<AmbitionsQuery['ambitions']>[number],
}>();

const localePath = useLocalePath();
const color = computed(() => props.ambition.color);
</script>

<style scoped>
.icon {
    @apply bg-white size-24 rounded-full flex justify-center items-center;

    color: v-bind(color);
}
</style>
